import Base from "./Base"

export default {
  httpBaseUri: "https://api.operandio.com",
  httpServiceBaseUri: "https://api.operandio.com/graphql",
  wsServiceBaseUri: "wss://api.operandio.com/graphql",

  clientKiosk: false,

  showConfigInTitle: true,
  configTitle: "[PREVIEW]",

  theme: {
    ...Base.theme,

    logoContainer: "images-dev"
  },

  uploader: {
    ...Base.uploader,

    imageViewerBaseUri: "https://image.operandio.com",
    imageViewerBucketName: "operandio-content-ap-southeast-2",

    videoViewerBaseUri: "https://video.operandio.com",
    videoViewerBucketName: "operandio-content-ap-southeast-2",

    scormUploadBucketName: "operandio-scorm-quarantine",
    scormViewerBaseUri: "https://scorm.operandio.com"
  },

  stripe: {
    publishableKey:
      "pk_live_51GxNIsCmvyAu99J00nBfNgcypgin24GX4q97w3Dxa0Whoq5OsOtZSsGzpZaVbTwh1PGZ71WcrKGma5YJQ2BktMtn00bimwwkVm"
  },

  analytics: {
    ...Base.analytics,

    mixpanel: {
      enabled: true,
      token: "a0740ae1cb6ae5ddf2eaf445b5ceaeae",
      settings: {
        debug: false,
        track_pageview: true,
        persistence: "localStorage"
      }
    }
  },

  errors: {
    ...Base.errors,

    showDetail: false,
    showGraphQLErrorNotification: true
  }
}
